import { createClient } from '@supabase/supabase-js';

// The recovered Jonny's Towing project is now the authoritative portal backend.
// These are public client connection values (not service-role credentials).
const PRIMARY_URL =
  import.meta.env.VITE_PRIMARY_SUPABASE_URL ||
  'https://iygmzptwotjkftqoreov.supabase.co';
const PRIMARY_KEY =
  import.meta.env.VITE_PRIMARY_SUPABASE_ANON_KEY ||
  'sb_publishable_Zu7j51c5bjcg_oYuurk6vA_xk9oExM5';

// During the recovery period, production may still have the historical project
// configured in the original VITE_SUPABASE_* variables. Treat that project as
// a read/authentication bridge only; all normal application access uses primary.
const configuredLegacyUrl =
  import.meta.env.VITE_LEGACY_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL;
const configuredLegacyKey =
  import.meta.env.VITE_LEGACY_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY;

const legacyIsDistinct =
  Boolean(configuredLegacyUrl && configuredLegacyKey) &&
  configuredLegacyUrl !== PRIMARY_URL;

export const isSupabaseConfigured = Boolean(PRIMARY_URL && PRIMARY_KEY);

export const primarySupabase = createClient(PRIMARY_URL, PRIMARY_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'jt-primary-auth',
  },
});

export const legacySupabase = legacyIsDistinct
  ? createClient(configuredLegacyUrl, configuredLegacyKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
        storageKey: 'jt-legacy-auth',
      },
    })
  : null;

// Existing application code imports `supabase`; keep that API stable while
// ensuring every new read/write targets the recovered primary project.
export const supabase = primarySupabase;
